const storageKey = "auth-token";

const authStorage = {
  storeToken(token: string) {
    localStorage.setItem(storageKey, token);
  },
  removeToken() {
    localStorage.removeItem(storageKey);
  },
  getToken() {
    return localStorage.getItem(storageKey);
  },
};

export default authStorage;
